// extracted by mini-css-extract-plugin
module.exports = {"container":"_2787e5dfdf--container--CoBty","container--moved":"_2787e5dfdf--container--moved--zsOCM","close":"_2787e5dfdf--close--oUeD_"};